import React, { useState } from 'react'
import { Button } from '../../../nq-component'

function CustomFilter({ onSubmit, onCancel }) {
//   const [name, setName] = useState('')
//   const [status, setStatus] = useState('')
  const [date, setDate] = useState('')

  function handleSubmit() {
    const where = {}

    // const or = []

    // if (name) {
    //     or.push({ 'client.first_name': { $regex: name, $options: 'i' } })
    //     or.push({ 'client.last_name': { $regex: name, $options: 'i' } })
    // }

    // if (or.length > 0) {
    //     where['$or'] = or
    // }

    // if (status) {
    //   where['status'] = status
    // }

    if (date) {
      where['created'] = {
        $gte: new Date(date).toISOString().split('T')[0] + 'T00:00:00.000Z',
        $lte: new Date(date).toISOString().split('T')[0] + 'T23:59:59.999Z',
      }
    }

    onSubmit(where)
  }

  function clearFilters() {
    // setName('')
    // setStatus('')
    setDate('')
    handleSubmit()
  }

  return (
    <div>
      {/* <div className='mb-3'>
        <label className='form-label fw-bolder'>Name</label>
        <input
          type='text'
          className='form-control'
          placeholder='Enter name...'
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div> */}

      <div className='mb-3'>
        <label className='form-label fw-bolder'>Date</label>
        <input
          type='date'
          className='form-control'
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>

      {/* <div className='mb-3'>
        <label className='form-label fw-bolder'>Status</label>
        <select
          className='form-select'
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option disabled value=''>Select Status</option>
          <option className='text-dark' value='Draft'>Draft</option>
          <option className='text-warning' value='Pending (Warm Lead)'>Pending (Warm Lead)</option>
          <option className='text-success' value='Pending (Cold Lead)'>Pending (Cold Lead)</option>
          <option className='text-danger' value='Cancelled'>Cancelled</option>
          <option className='text-primary' value='Closed Deal'>Closed Deal</option>
        </select>
      </div> */}

      <div className='d-flex justify-content-end align-items-end gap-2 mt-4'>
        <Button className='btn btn-light fw-bolder w-100' onClick={clearFilters}>
          Clear
        </Button>
        <Button className='btn btn-primary fw-bolder text-black w-100' onClick={handleSubmit}>
          Apply 
        </Button>
      </div>
    </div>
  )
}

export default CustomFilter
